<view-child-eligibility-status *ngIf="studentId" [studentId]="studentId"></view-child-eligibility-status>

<div class="margin-top-lg">
	<view-child-eligibility-checkboxes *ngIf="studentId" [studentId]="studentId"></view-child-eligibility-checkboxes>
</div>